<div class="">
  <button
    type="button"
    class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
    (click)="fileControlRef.click()"
  >
    <span class="text-[0.7rem]"> {{ label }} </span>
    <img
      class="rounded-full ml-[4px]"
      src="assets/icons/document.svg"
      alt="document icon"
    />
  </button>
  <input
    type="file"
    #fileControlRef
    (change)="onFileUpload($event)"
    multiple
    hidden
  />
</div>